import { useTickSoundInteraction } from '@/hooks';
import type { MenuItem } from '@/types/shop';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

type Props = {
    tabIndex: number;
    showReview?: boolean;
    menuList?: MenuItem[];
};

export const ShopMenu = ({ tabIndex, showReview, menuList }: Props) => {
    const { t } = useTranslation();
    const { playTick } = useTickSoundInteraction();

    return (
        <div
            className={clsx(
                'widescreen:w-[calc(410*var(--vw-unit))] contrast:border-not-contrast-white bg-bg-white flex h-[calc(404*var(--vh-unit))] w-[calc(680*var(--vw-unit))] flex-col rounded-md border-[calc(2*var(--vh-unit))] border-transparent px-[calc(36*var(--vw-unit))] py-[calc(40*var(--vh-unit))]',
                {
                    'w-[calc(410*var(--vw-unit))]!': showReview,
                }
            )}
        >
            <div className="flex items-center gap-[calc(10*var(--vw-unit))] py-[calc(5*var(--vh-unit))]">
                <p
                    data-modal-region
                    data-modal-region-order={tabIndex}
                    tabIndex={tabIndex}
                    data-interactive
                    aria-label={t('shop.label.menu')}
                    className="text-text-main01 text-[calc(26*var(--vh-unit))] leading-[calc(30*var(--vh-unit))] font-bold uppercase focus-border "
                >
                    {t('shop.label.menu')}
                </p>
                <div className="bg-text-black h-[calc(1*var(--vh-unit))] w-full" />
            </div>
            <div className="scrollbar-custom-gray-99938f scrollbar-w-4 mt-[calc(16*var(--vh-unit))] flex max-h-[calc(268*var(--vh-unit))] flex-1 flex-col gap-[calc(20*var(--vh-unit))] overflow-y-auto pr-[calc(24*var(--vw-unit))]">
                {menuList &&
                    menuList.map((menu) => (
                        <div
                            tabIndex={tabIndex}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    playTick();
                                    e.preventDefault();
                                    e.stopPropagation();
                                }
                            }}
                            onMouseDown={(e) => {
                                e.preventDefault();
                            }}
                            data-interactive
                            aria-label={t('shop.modal.tts.carousel.menu_price', { menuName: menu.name, price: menu.price })}
                            key={menu.id}
                            className="text-text-main01 flex items-center justify-between text-[calc(22*var(--vh-unit))] leading-[calc(28*var(--vh-unit))] font-medium focus-border "
                        >
                            <div className="widescreen:w-[calc(198*var(--vw-unit))] w-[calc(476*var(--vw-unit))] max-w-[75%] truncate">{menu.name}</div>
                            <div className="number flex-1 text-right">{Number(menu.price).toLocaleString()}</div>
                        </div>
                    ))}
            </div>
        </div>
    );
};
